import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { Button } from 'oxyrion-ui/lib';
import Loader from 'oxyrion-ui/lib/Loader';
import Icon from 'oxyrion-ui/lib/Icon';
import { __, formatPrice, formatNumber } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import QuantityPicker from '../../../../Components/QuantityPicker';
import ErrorMessage from '../../../../Components/ErrorMessage';
import AddToCartWidget from '../../../../Components/AddToCartWidget';
import { FlexBox } from '../../../../Components/ReusableComponents';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Space = styled.div`
  width: ${rem(12)};
  height: ${rem(12)};
`;

const AddToCardWrapper = styled.div`
  height: ${rem(32)};
  width: ${rem(32)};
  border: 1px solid #70af00;
  border-radius: ${rem(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  cursor: pointer;
`;

class ProductRows extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Riadky ponuky'),
      notFoundMessage: __('Ľutujeme ponuky sa nenašli'),
      isProduct: true,
      showFilter: false,
      showHeader: false,
      sorter: 'line_no',
      displayedColumns: {},
      buttonsSwitch: [],
      productsToAdd: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  showAddToCart(product) {
    this.setState({
      showAddToCart: true,
      productToAdd: product,
    });
  }

  init() {
    const {
      actualPage,

      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    this.setState(
      {
        loading: true,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
      },
      async () => {
        await this.fetchData();
        this.setTableHeight();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, sorter } = this.state;
      const { ids } = this.props;
      this.setState({ loading: true, showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (ids) {
        params.offerIds = ids;
      }

      params.sorter = sorter;

      const newData = await API2.getB2BPriceOffersProductsAction(params);
      this.setState({
        tableItems: newData.products.map(p =>
          Object.assign(p, { _id: p.value }),
        ),

        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
        addToCartLoading: false,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({
        error: __('Nepodarilo sa načítať produkty cenovej ponuky'),
      });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;
    switch (s) {
      case '_id':
        if (sorter === 'line_no') {
          newSorter = '-line_no';
        } else {
          newSorter = 'line_no';
        }
        break;
      case 'description':
        if (sorter === 'description') {
          newSorter = '-description';
        } else {
          newSorter = 'description';
        }
        break;
      case 'CENA':
        if (sorter === 'Price') {
          newSorter = '-Price';
        } else {
          newSorter = 'Price';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  async addProductsToCart() {
    const { tableItems } = this.state;

    const products = tableItems;

    this.setState({
      addToCartLoading: true,
    });

    try {
      const { activeCart } = this.props;
      const myCarts = await API2.getCartsAction();
      const selectedCart = myCarts.carts.find(c => c._id === activeCart);

      const result = await API2.postPriceOffersProductsCartItemsAction(
        selectedCart._id,
        {
          body: products.map(p => {
            const data = {
              product_id: p.value,
              quantity: Number(p.quantity),
              offer_id: p.offer_id,
            };

            if (p.shade && p.shade.name) {
              data.color_code = p.shade.name;
            }

            if (p.shade && p.shade.colorCardId) {
              data.colorCardId = p.shade.colorCardId;
              data.toningSystemId = p.shade.toningSystemId;
              data.coefficient = 1;
            }

            return data;
          }),
        },
      );

      actions.updateCarts(result.cart);

      this.setState({
        success: __('Zvolené produkty boli pridané do košíka'),
      });

      this.fetchData();
    } catch (e) {
      console.log(e);

      this.setState({
        error: __('Produkty sa nepodarilo vložiť do košíka'),
      });
    }
  }

  createColumns() {
    const result = [
      {
        accessor: 'label',

        Header: () => <IconTd>{__('Názov produktu')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'shade',
        Header: () => <IconTd>{__('Odtieň')}</IconTd>,
        maxWidth: 180,
        Cell: props => {
          return (
            <P>
              {props.value && props.value.name
                ? props.value.name
                : __('Bez odtieňa')}
            </P>
          );
        },
      },
      {
        accessor: 'discount',
        Header: () => <IconTd>{__('Zľava')}</IconTd>,
        maxWidth: 80,
        Cell: props => {
          return <P>{props.value && formatNumber(props.value)}</P>;
        },
      },
      {
        accessor: 'Unit_Price_WD',
        Header: () => <IconTd>{__('Cena za kus bez zľavy')}</IconTd>,
        maxWidth: 170,
        Cell: props => {
          return <P>{formatPrice(props.value)}</P>;
        },
      },
      {
        accessor: 'Unit_Price',
        Header: () => <IconTd>{__('Cena za kus so zľavou')}</IconTd>,
        maxWidth: 170,
        Cell: props => {
          return <P>{formatPrice(props.value)}</P>;
        },
      },
      {
        accessor: 'Unit_Price',
        Header: () => <IconTd>{__('Spolu bez DPH')}</IconTd>,
        width: 130,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                amount: props.value.amount * props.original.quantity,
                currency: props.value.currency,
              })}
            </P>
          );
        },
      },
      {
        accessor: 'Unit_Price_VAT',
        Header: () => <IconTd>{__('Spolu s DPH')}</IconTd>,
        width: 130,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                amount: props.value.amount * props.original.quantity,
                currency: props.value.currency,
              })}
            </P>
          );
        },
      },

      {
        accessor: 'quantity',
        Header: () => <IconTd>{__('Množstvo')}</IconTd>,
        width: 130,
        Cell: props => {
          return (
            <P>
              <QuantityPicker
                readOnly={
                  this.props.productQuantityLoading === props.index ||
                  (props.original.payload &&
                    props.original.payload.campaignProduct)
                }
                value={props.value}
                changeValue={e => this.quantityHandler(e, props.index)}
              />
            </P>
          );
        },
      },
      {
        accessor: 'value',
        width: 50,

        Cell: row => {
          return (
            <FlexBox style={{ height: rem(40) }}>
              <AddToCardWrapper
                onClick={() => this.showAddToCart(row.original)}
              >
                {this.state.productToAdd &&
                this.state.productToAdd.value === row.original.value ? (
                  <Loader />
                ) : (
                  <Icon name="cart_add" color="#70af00" />
                )}
              </AddToCardWrapper>
            </FlexBox>
          );
        },
      },
    ];

    return result;
  }

  quantityHandler(value, index) {
    const { tableItems } = this.state;

    tableItems[index].quantity = value;

    this.setState({
      tableItems,
      error: false,
      success: false,
    });
  }

  handleProductsToAdd(id, isIn) {
    const { productsToAdd } = this.state;

    if (!isIn) {
      productsToAdd.push(id);
    } else {
      productsToAdd.splice(productsToAdd.indexOf(id), 1);
    }

    this.setState({ productsToAdd, error: false, success: false });
  }

  renderCustomBottomContent() {
    const { addToCartLoading } = this.state;
    return (
      <ButtonsWrapper>
        <Button
          loading={addToCartLoading}
          onClick={() => this.addProductsToCart()}
          small
          primary
        >
          {__('Vložiť všetky produkty do košíka')}
        </Button>
        <Space />
      </ButtonsWrapper>
    );
  }

  render() {
    const { success, error, productToAdd } = this.state;

    return (
      <React.Fragment>
        <ErrorMessage display={error} text={error} />
        <ErrorMessage display={success} success text={success} timeToShow={3} />
        <AddToCartWidget
          history={this.props.history}
          callback={() => {
            this.setState({
              productToAdd: undefined,
              success: __('Produkt bol pridaný do košíka'),
            });
          }}
          closeCallBack={() =>
            this.setState({
              productToAdd: undefined,
            })
          }
          product={productToAdd && productToAdd}
          colorCode={
            productToAdd && productToAdd.shade && productToAdd.shade.name
          }
          toningSystemId={
            productToAdd &&
            productToAdd.shade &&
            productToAdd.shade.toningSystemId
          }
          colorCardId={
            productToAdd && productToAdd.shade && productToAdd.shade.colorCardId
          }
          defaultQuantity={productToAdd && productToAdd.quantity}
        />
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductRows);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Quotes/Rows/index.jsx